import { useEffect } from 'react';

export const useNextPrevEvent = (
  handleNext: () => void,
  handlePrev: () => void,
  disabledNext: boolean,
  disabledPrev: boolean,
) => {
  useEffect(() => {
    const handleNextKey = (event: KeyboardEvent) => {
      if (!disabledNext && event.key === 'ArrowRight') {
        handleNext();
      }
    };
    const handlePrevKey = (event: KeyboardEvent) => {
      if (!disabledPrev && event.key === 'ArrowLeft') {
        handlePrev();
      }
    };

    document.addEventListener('keydown', handleNextKey, false);
    document.addEventListener('keydown', handlePrevKey, false);

    return () => {
      document.removeEventListener('keydown', handleNextKey, false);
      document.removeEventListener('keydown', handlePrevKey, false);
    };
  }, [disabledNext, disabledPrev, handleNext, handlePrev]);
};
